export default __webpack_public_path__ + "static/media/companylogo1.18d3955a.png";